import {
  isServiceAuthDecision,
  MCP_APPLICATION_TYPES,
} from "../shared/constants";
import type { CloudflareAccessApplication } from "../shared/types";
import { EmptyState } from "./AdminUi";

export function McpReadinessCard({
  applications,
}: {
  applications: CloudflareAccessApplication[];
}) {
  const mcpApplications = applications.filter((application) =>
    MCP_APPLICATION_TYPES.some((type) => type === application.type),
  );
  return (
    <section className="panel-card mcp-readiness-card">
      <header className="panel-card__header">
        <div>
          <span className="eyebrow">AI controls</span>
          <h2>MCP readiness</h2>
        </div>
        <span className="panel-status">{mcpApplications.length}</span>
      </header>
      {mcpApplications.length ? (
        <ul className="mcp-app-list">
          {mcpApplications.map((application) => {
            const serviceAuth = application.policies.some((policy) =>
              isServiceAuthDecision(policy.decision),
            );
            return (
              <li key={application.id}>
                <span>
                  <strong>{application.name}</strong>
                  <small>{application.domain}</small>
                </span>
                <span
                  className={`panel-status panel-status--${serviceAuth ? "positive" : "warning"}`}
                >
                  {serviceAuth ? "Service Auth policy" : "User auth only"}
                </span>
              </li>
            );
          })}
        </ul>
      ) : (
        <EmptyState
          compact
          hint="Add an MCP server or portal in Cloudflare AI controls."
          title="No MCP Access applications"
        />
      )}
    </section>
  );
}
